<div class="btn-float">
  <i class="bi bi-file-earmark-plus-fill"></i>
</div>
<div class="dashboard-card list-card">
  <div class="widget-header">
    <h5>
      Coupons Master List
    </h5>
    <!-- <select class="form-select w-50" [(ngModel)]="inst_id">
				<option value="0">
						Select Institute
				</option>
				@for(inst of institutes; track $index) {
						<option value="{{inst.id}}">{{inst.inst_name}}</option>
				}
		</select> -->
    <button class="btn btn-sm btn-light py-0" data-bs-toggle="modal" data-bs-target="#frmBackdrop" (click)="newClick()">
      +Add New
    </button>
  </div>

  <div class="w-100">
    <table id="orgTable" class="table table-striped w-100">
      <thead>
        <tr>
          <th>#</th>
          <th>Code</th>
          <th>Type</th>
          <th>Value</th>
          <th>Valid From</th>
          <th>Valid Until</th>
          <th>Uses</th>
          <th>Active?</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @for(data of allData; track $index; let idx = $index;) {
        <tr>
          <td>{{idx+1}}.</td>
          <td>{{data.code}}</td>
          <td>{{data.disc_type=='per' ? 'Percentage' : 'Flat'}}</td>
          <td>{{data.disc_type=='per' ? data.disc_value + '%' : '₹ '+data.disc_value+'/-'}}</td>
          <td>{{dataService.ymd2dmy(data.valid_from)}}</td>
          <td>{{dataService.ymd2dmy(data.valid_until)}}</td>
          <td>{{data.bal_uses}} / {{data.max_uses}}</td>
          <td>{{data.is_active ? 'Yes' : 'No'}}</td>
          <td>
            <div class="d-flex gap-2">
              <span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
                (click)="editClick(data)" title="Modify">
                <i class="bi bi-pencil-square text-success"></i>
              </span>
              <span style="cursor: pointer;" (click)="deleteClick(data.id)" title="Delete">
                <i class="bi bi-trash3-fill text-danger"></i>
              </span>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>

    <div class="text-danger" align="center" *ngIf="allData && !allData.length && !loading">
      <i class="bi bi-x-circle"></i> No data available.
      <span (click)="ngOnInit()" style="cursor: pointer;"><u>Refresh Data</u></span>
    </div>
  </div>
</div>

<!-- <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel"
	style="width: 500px;">
	<div class="offcanvas-header">
		<h5 class="offcanvas-title" id="offcanvasRightLabel">Coupon Master</h5>
		<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
	</div>
	<div class="offcanvas-body">
//
	</div>
</div> -->

<div class="modal fade" id="frmBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="frmBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="frmBackdropLabel">Coupon Master Form</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body py-3">

        <div class="row g-3 mb-3">
          <div class="col-md-12">
            <label class="form-label">
              Coupon Code <span class="required">*</span>
            </label>
            <input type="text" class="form-control" [(ngModel)]="frmData.code" placeholder="e.g., SAVE20" />
          </div>
        </div>

        <div class="row g-3 mb-3">
          <div class="col-md-12">
            <label class="form-label">Discount Type</label>
            <select class="form-control form-select" [(ngModel)]="frmData.disc_type">
              <option value="">Select Type</option>
              <option value="per">Percentage</option>
              <option value="flat">Flat Amount</option>
            </select>
          </div>
        </div>

        <div class="row g-3 mb-3">
          <div class="col-6 form-group">
            <label class="form-label">Discount Value</label>
            <input type="number" class="form-control" [(ngModel)]="frmData.disc_value" />
          </div>
          <div class="col-6 form-group">
            <label class="form-label">Max Uses</label>
            <input type="number" class="form-control" [(ngModel)]="frmData.max_uses" placeholder="Leave empty for unlimited" />
          </div>
        </div>

        <div class="row g-3 mb-3">
          <div class="col-4 form-group">
            <label class="form-label">Valid From</label>
            <input type="date" class="form-control" [(ngModel)]="frmData.valid_from" />
          </div>
          <div class="col-4 form-group">
            <label class="form-label">Valid Until</label>
            <input type="date" class="form-control" [(ngModel)]="frmData.valid_until" />
          </div>
          <div class="col-4 form-group">
            <label class="form-label fw-semibold">
              Active
              <span class="text-danger">*</span>
            </label>

            <select class="form-select" name="is_active" [(ngModel)]="frmData.is_active" #is_active="ngModel" required>
              <option ngValue="">Select Status</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>

            <div class="text-danger small mt-1" *ngIf="is_active.invalid && is_active.touched">
              Please select status.
            </div>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="col-2 btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="col-2 btn btn-sm btn-primary" data-bs-dismiss="modal"
          (click)="isEdit ? doUpdate() : doSave();">
          {{isEdit ? 'Update' : 'Save'}}
        </button>
      </div>
    </div>
  </div>
</div>